import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Allows the dashboard route for Handwerker and Endkunde — the route's
 * component then renders the role-appropriate dashboard internally. Anyone
 * else (e.g. Admin or unknown role) bounces to the home page.
 */
export const handwerkerRoleGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.currentUser;

  if (user?.rolle === 'Handwerker' || user?.rolle === 'Endkunde') return true;

  return router.createUrlTree(['/']);
};
